import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { Box, Button, Container, Typography, useMediaQuery, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {SystemUpdateAltOutlined } from '@mui/icons-material';
import { callPostApiapp } from '../API/ApiCallFunction';
import GradientLoader from '../CommanComponents/GradientLoader';
import { useLocation } from 'react-router-dom';
export default function RedeemedCustHistory() {
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [datar, setDatar] = useState([]);
  const [filterLimit, setFilterLimit] = useState(100);
  const [filterStatus, setFilterStatus] = useState('Redeemed');
  const [filterLotNo, setFilterLotNo] = useState('');
  const [locationftr, setlocationftr] = useState('');
  const [filterLoadedNo, setFilterLoadedNo] = useState('');
  const [totalamtt, settotalamttt] = useState('');
 const location = useLocation();
  const { userName, custid } = location.state || {};


  //API
  const QRListApi= async (limit = filterLimit) => {
      try {
        setLoading(true);
        const storeid = user.store_info.store_id;
        const payload = { mod: "CASHI_QRCODE_LIST", data_arr: { store_id:storeid, start: '0', limit:"1000",customer_id:custid},
         };
        const apiResult = await callPostApiapp("cashi-cust-qrcode", payload);
        //[{"redeem_id":78,"qrcode_id":305,"store_id":1020,"customer_id":1264,"qrcode_number":"102010931761636187520","redeem_amount":"10.00","date_added":"29-Oct-25 04:23 PM"},
        if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
         const sorted = apiResult.data.slice().sort((a, b) => new Date(b.date_added) - new Date(a.date_added));
   
       const totalRedeemAmount = sorted.reduce((sum, item) => {
  // convert to number safely, since item.redeem_amount may be string
  return sum + Number(item.redeem_amount || 0);
}, 0);
settotalamttt(totalRedeemAmount);
         const formattedData = sorted.map((item, index) => ({
          id: index + 1,
          lotno: item.qrcode_id || "NA",
          qr: item.qrcode_number || "NA",
          redeemdate:item.date_added,
          amount: item.redeem_amount || "0",
          
  
        }));

        setDatar(formattedData);
         
        } else {
         setDatar([]);  
        }
      } catch (err) { 
      } finally {
        setLoading(false);
      }
    }; 

  const clearFun = async () => {
    const newStatus = 'Redeemed';
    const newLotNo = '';
    const newLoadedNo = '';
    const lko = '';
    const newlimit = 100;
    setFilterStatus(newStatus);
    setFilterLotNo(newLotNo);
    setFilterLoadedNo(newLoadedNo);
    setFilterLimit(newlimit);
    setlocationftr(lko);
    await QRListApi(newStatus,newLoadedNo, newLoadedNo, newlimit);
    }

  useEffect(() => {
    if (isMobile && apiRef.current) {
      apiRef.current.autosizeColumns({ includeHeaders: true });
    }
    QRListApi(RedeemedCustHistory, '','', filterLimit);
  }, [isMobile]);
 
 
 const columns = [
  { field: 'id', headerName: 'Sr no.', flex: isMobile ? undefined : 0.1},
  { field: 'qr', headerName: 'QR',  flex: isMobile ? undefined : 0.6,},
  { field: 'amount', headerName: 'Amount', flex: isMobile ? undefined :0.6 },
  { field: 'redeemdate', headerName: 'Date', flex: isMobile ? undefined : 0.2 },
 ]

  return (
    <Container>
      <Box sx={{ display: 'contents'}}>
        <Box sx={{ display: 'flex', justifyContent: 'start', mb: 1 }}>
                    <Button
                  variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}
                  onClick={() => navigate('/dashboardPlus/redeemed')} >  Back </Button>

          </Box>
          {/* <Box sx={{ display: 'flex', justifyContent: 'end', mb:1 }}>
              <Typography sx={{mx:1, fontSize:'22px', justifyContent:'end'}}> Total Disbursed Amount:-₹  {totalamtt}</Typography>

          </Box> */}
        </Box>
     
   <Box
  sx={{
    background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
    p: 1,
    color: '#ffffff',
    borderRadius: '4px',
    mb: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between' // 👈 pushes left & right content apart
  }}
>
  {/* Left side */}
  <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', m: 0 }}>
    <SystemUpdateAltOutlined sx={{ mx: 1, fontSize: '22px' }} />
    Redeemed QR History List of {userName}
  </Typography>

  {/* Right side */}
  <Typography sx={{ mx: 1, fontSize: '18px', fontWeight: 500 }}>
    Total Disbursed Amount: ₹{totalamtt}
  </Typography>
</Box>



      {/* DataGrid */}
      <Box sx={{ height: 'auto',  width: '100%', mb: 4 }}>
        <DataGrid
          rows={datar} showToolbar  columns={columns} disableRowSelectionOnClick getRowHeight={() => "auto"}
           initialState={{ pagination: { paginationModel: { pageSize: 10 },}, }} pageSizeOptions={[10, 25, 50]}
          sx={{
             '& .MuiDataGrid-cell': {
               whiteSpace: 'normal',     // Allow wrapping
               lineHeight:'20px',
               wordBreak: 'break-word', 
      
               display: 'flex',
              alignItems: 'center', // Vertically center content
              gap: '4px'},
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: 14,
              fontWeight: '600',
               whiteSpace: 'normal',
              wordBreak: 'break-word'
            },
          }}
         />
      </Box>
      {loading && <GradientLoader text="Loading" />} 
    </Container>
  );
}
